/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ExportExcelRequest { 
    /**
     * The collection in mongo
     */
    type: ExportExcelRequest.TypeEnum;
    /**
     * Filters object for query as JSON string
     */
    filter: string;
    /**
     * Filters options e.g. sort, projection as JSON string
     */
    filterOptions?: string;
    /**
     * Overwrite the default filename. Date will be appended
     */
    fileName?: string;
    /**
     * Add date and time to filename. If false, only date. Default is true
     */
    addTime?: boolean;
    /**
     * Format date in specific timezone
     */
    timeZone?: string;
}
export namespace ExportExcelRequest {
    export type TypeEnum = 'assets' | 'users' | 'projects' | 'tasks' | 'teams' | 'assethistories' | 'loginhistories';
    export const TypeEnum = {
        Assets: 'assets' as TypeEnum,
        Users: 'users' as TypeEnum,
        Projects: 'projects' as TypeEnum,
        Tasks: 'tasks' as TypeEnum,
        Teams: 'teams' as TypeEnum,
        Assethistories: 'assethistories' as TypeEnum,
        Loginhistories: 'loginhistories' as TypeEnum
    };
}


